module.exports = __webpack_public_path__ + "static/media/chevron-right.8c83a343.svg";